/**
 * Hook that (re)computes intensity data whenever the loaded beatmap
 * or active difficulty changes. Runs computation in a microtask
 * to avoid blocking the initial render.
 */

import { useEffect } from 'react';
import { useEditorStore } from '../store/editorStore';
import { computeIntensity } from '../heatmap/intensityEngine';

export function useIntensityCompute() {
  const beatmap = useEditorStore(s => s.beatmap);
  const activeDifficulty = useEditorStore(s => s.activeDifficulty);
  const setIntensityData = useEditorStore(s => s.setIntensityData);

  useEffect(() => {
    if (!beatmap) {
      setIntensityData(null);
      return;
    }

    const diff = beatmap.difficulties[activeDifficulty];
    if (!diff || diff.notes.length === 0) {
      setIntensityData(null);
      return;
    }

    // Compute in microtask to avoid blocking render
    queueMicrotask(() => {
      const data = computeIntensity(diff.notes, beatmap.bpm);
      setIntensityData(data);
    });
  }, [beatmap, activeDifficulty, setIntensityData]);
}
